import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "@/config";
import { Heart } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2D312E] text-[#EAE5DC]">
    <div className="max-w-6xl mx-auto px-4 py-16 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-primary-foreground">
            <Heart className="w-5 h-5" />
          </span>
          <span className="font-serif text-xl font-semibold">MyySpace</span>
        </div>
        <p className="text-sm text-[#EAE5DC]/70 leading-relaxed max-w-xs">
          A safe, judgment-free space where your feelings are valid and you are truly heard.
        </p>
      </div>

      <div>
        <h4 className="font-serif text-lg mb-4">Explore</h4>
        <ul className="space-y-2 text-sm text-[#EAE5DC]/70">
          <li><a href="/#why-us" className="hover:text-white transition-colors duration-300">Why Talk to Us</a></li>
          <li><a href="/#how-it-works" className="hover:text-white transition-colors duration-300">How It Works</a></li>
          <li><a href="/#pricing" className="hover:text-white transition-colors duration-300">Pricing</a></li>
          <li><a href="/#booking" className="hover:text-white transition-colors duration-300">Request a Session</a></li>
        </ul>
      </div>

      <div>
        <h4 className="font-serif text-lg mb-4">Legal & Contact</h4>
        <ul className="space-y-2 text-sm text-[#EAE5DC]/70">
          <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors duration-300">Terms of Service</Link></li>
          <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-300">Privacy Policy</Link></li>
          <li><Link to="/refund" data-testid="footer-refund-link" className="hover:text-white transition-colors duration-300">Refund & Cancellation</Link></li>
          <li>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-[#8fd6a4] hover:text-white transition-colors duration-300">
              Chat with us on WhatsApp
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 py-6 text-xs text-[#EAE5DC]/50 leading-relaxed">
        <p className="mb-2">
          MyySpace is an emotional support, listening and guidance service by an experienced, compassionate listener.
          It is NOT medical, psychological, psychiatric, or crisis treatment, and not a substitute for professional clinical care.
        </p>
        <p>© {new Date().getFullYear()} MyySpace. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
